import { CollectionScreen } from "@components/Collection";

export default CollectionScreen;
